import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { useEffect } from 'react'

import { ALLOWED_REQUEST_TYPES } from '../constants'

import { useActiveSpecializationCriteriaHandlers } from './useActiveSpecializationCriteriaHandlers'

interface IProps {
  code: string
  requestType: RequestTypes
  countryISO: string
}

export const useFetchActiveSpecializationCriteria = ({ code, requestType, countryISO }: IProps) => {
  const {
    fetchSpecializationCriteria,
    fetchRevenueCriteria,
    specializationCriteria,
    revenueCriteriaThresholds,
    isSpecializationCriteriaLoading,
    isRevenueCriteriaLoading,
  } = useActiveSpecializationCriteriaHandlers()

  useEffect(() => {
    if (!(code && requestType && countryISO) || !ALLOWED_REQUEST_TYPES.includes(requestType)) {
      return
    }

    Promise.all([
      fetchSpecializationCriteria(code, requestType),
      fetchRevenueCriteria(code, countryISO),
    ])
  }, [code, requestType, countryISO, fetchSpecializationCriteria, fetchRevenueCriteria])

  return {
    isCriteriaLoading: isSpecializationCriteriaLoading || isRevenueCriteriaLoading,
    specializationCriteria,
    revenueCriteriaThresholds,
  }
}
